import getDashboardData from './mapping/dashboardData'
import getReportsData from './mapping/reportsData'
import getFeedbackFlows from './mapping/feedbackData'
import defaultState from './defaultState' 

export function dataReducer(data: any, action: any) {
    switch (action.type) {
      case 'setRightPanel': {
        const newData = {...data}
        newData.rightPanel = action.rightPanel
        if(!action.rightPanel) {
          newData.chat = {...defaultState().chat}
        }
        return newData;
      }
      case 'setAcctSelected': {
        const newData = {...data}
        newData.acctSelected = action.acctSelected
        return newData;
      }
      case 'setDashboardCardValue': {
        const newData = {...data }
        newData.monitorSelected[action.monitor] = action.selected
        if(newData?.dashboard?.cards[action.id] && newData?.dashboard?.monitor) {
          newData.dashboard.cards[action.id].value = 
            newData?.dashboard?.monitor[action.monitor][action.selected]?.value || 0
          newData.dashboard.cards[action.id].desc = 
            newData?.dashboard?.monitor[action.monitor][action.selected]?.cardDesc || ''        
        }
        return newData;
      }
      case 'setDashboardData': {
        const newData = {...data }
        try {
          newData.dashboard = getDashboardData(action.dashboardData, { 
            monitorSelected: newData?.monitorSelected
          }, action.weather)
        } catch(e) {
          console.log(e)
        }
        return newData;
      }
      case 'setEnergySavingMode': {
        const newData = {...data}
        newData.dashboard.hotwater.card.desc = `Energy Saving Mode ${action.status}`
        newData.dashboard.hotwater.energySavingMode.status = action.status
        return newData;
      }
      case 'setReportData': {
        const newData = {...data}
        newData.reports = getReportsData(action.selectedReportData)
        return newData;
      }
      case 'setReportSelected': {  
        const newData = {...data}
        newData.reportSelected = action.selected;
        return newData;
      }
      case 'setSavingsData': {
        const newData = {...data}
        newData.savings = action?.annualSavingsReports?.savingsReports || []
        if(!newData.savingsSelected) {
          newData.savingsSelected = newData.savings[0]?.id
        }
        return newData;
      }
      case 'setSavingsSelected': {  
        const newData = {...data}
        newData.savingsSelected = action.selected;
        return newData;
      }
      case 'setHotwaterEnergySavingMode': {
        const newData = {...data}
        newData.dashboard.hotwater.isEnabled = action.enabled;
        if(action.enabled) {
          newData.dashboard.hotwater.card.desc = 'Energy saving mode enabled'
        } else {
          newData.dashboard.hotwater.card.desc = 'Energy saving disabled'
        }
        return newData;
      }
      case 'setFeedbackFlows': {
        const newData = {...data}
        newData.feedback = getFeedbackFlows(action.feedbackFlows)
        return newData;
      }
      case 'setDirectDebitBank': {
        const newData = {...data}
        newData.directDebit = action.directDebitBank
        return newData;
      }
      case 'rotateImgSuffix': {
        const newData = {...data}
        newData.gridSuffix = ''
        newData.solarSuffix = ''
        if(action.gridImporting) {
          newData.gridSuffix = 'A'
        }
        if(action.solarActive) {
          newData.solarSuffix = 'A'
        }
        if(action.charging) {
          newData.batterySuffix = ''
          if(newData.batteryImg>4) {
            newData.batteryImg = action.minLevel
          } else {
            newData.batteryImg++
          }
        } else if(action.disCharging){
          newData.batterySuffix = 'A'
          if(newData.batteryImg<1) {
            newData.batteryImg = action.minLevel
          } else {
            newData.batteryImg--
          }
        } else {
          newData.batterySuffix = ''
          newData.batteryImg = action.minLevel
        }
        return newData;
      }
      case 'newAiConversation': {  
        const newData = {...data}
        const newMessage: any = {}
        newMessage[`${action.key}`] = {
          from: action.from,
          timeMs: Date.now(),
          message: action.message
        }
        newData.chat.messages = {...newData.chat.messages, ...newMessage };
        newData.chat.chatWindow = action.chatWindow
        if(action.from === "user") newData.chat.asking = true
        if(action.from === "sunny") newData.chat.asking = false
        if(action.from === "system") newData.chat.asking = false
        return newData;
      }
      
      default: {
        throw Error('Unknown action: ' + action.type);
      }
    }
  }